import { ChangeDetectorRef, Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { ApiService } from 'app/api.service';
import { AppService } from 'app/app.service';
import { Pagination } from 'app/shared/pagination';
import { TaskService } from 'app/task/task.service';
import { UIModalBaseComponent } from 'app/ui/ui-modal-base.component';
import { DeferredAction } from 'app/shared/deferred-action';
import { ModalTaskDetailsComponent } from '../modal-task-details/modal-task-details.component';

declare const Mangler: any;

@Component({
	selector: 'modal-select-task',
	templateUrl: './modal-select-task.component.html',
	styles: [`
		.sticky-tabs {
			position: sticky;
			top: -1.5rem;
			z-index: 10;
			background-color: #fff;
		}

		tr .sticky {
			top: 2.9rem;
		}
	`]
})
export class ModalSelectTaskComponent extends UIModalBaseComponent {

	@Input() embed = false;
	@ViewChild(ModalTaskDetailsComponent) modalTaskDetails: ModalTaskDetailsComponent;
	@Output() taskCount = new EventEmitter();

	teamList = [];
	labourTypeList = [];
	areaList = [];
	filterList = [];
	projectList = [];
	systemList = [];
	userList = [];
	pagination = new Pagination();
	projectId = null;
	stageList = [];
	tasks;
	stage = null;
	phaseList = [];
	refreshAction = new DeferredAction();
	mode = 'select';
	work_order_id;
	taskSearchList = '';
	taskSortList = '!id';
	showCompleted = true;
	has_work_order = null;

	constructor(
		public app: AppService,
		private api: ApiService,
		public service: TaskService,
		private cdr: ChangeDetectorRef
	) {
		super();
	}

	open(_mdata: any = null) {
		this.tasks = null;
		this.stage = _mdata.stage || null;
		this.showCompleted = _mdata.showCompleted !== undefined ? _mdata.showCompleted : true;
		this.mode = _mdata.mode || 'select';
		this.work_order_id = _mdata.work_order_id || null;
		this.has_work_order = _mdata.has_work_order || null;
		this.projectId = _mdata.project_id || null;
		this.stageList = this.service.stageList();
		this.service.stageFilter = 'all';
		if (this.stage) {
			this.stageList = this.stage;
			if (!this.stageList.includes('all')) {
				this.stageList.unshift('all');
			}
		}
		this.service.clearExpanded();
		this.taskSearchList = '';
		this.taskSortList = '!id';
		this.initialseFilters();
		if (this.projectId) {
			this.service.projectFilter = [this.projectId];
		}
		if (this.work_order_id) {
			this.service.workOrderFilter = [this.work_order_id];
		}
		this.refreshList();
		this.modal.open();
		this.cdr.detectChanges();
	}

	selectItem(item) {
		if (this.mode === 'book') this.modalTaskDetails.open({ id: item.id, mode: 'book' });
		else this.modal.close(item);
	}

	initialseFilters() {
		this.service.clearFilters();
		this.api.task.getFilterData({}, list => {
			this.filterList = list;
			this.labourTypeList = list.labour_types;
			this.areaList = list.areas;
			this.teamList = list.teams;
			this.projectList = list.projects;
			this.systemList = list.category_groups;
			this.userList = list.users;
			this.phaseList = list.phases;
			this.cdr.detectChanges();
		}, error => {
			this.app.notifications.showDanger(error.message);
		});
	}

	refreshList(delay = 0) {
		const options = {
			stage: this.resolveStage(),
			project: this.getFilteredValue(this.service.projectFilter),
			work_order: this.getFilteredValue(this.service.workOrderFilter),
			system: this.getFilteredValue(this.service.systemFilter),
			area: this.getFilteredValue(this.service.areaFilter),
			labour_type: this.getFilteredValue(this.service.labourTypeFilter),
			team: this.getFilteredValue(this.service.teamFilter),
			user: this.getFilteredValue(this.service.userFilter),
			phase: this.getFilteredValue(this.service.phaseFilter),
			sort: this.taskSortList,
			paginated: 1,
			page_size: this.pagination.pageSize,
			page_number: this.pagination.page,
			keywords: this.taskSearchList,
			show_completed: this.showCompleted ? 1 : 0,
			has_work_order: this.has_work_order
		};

		const deferredCount = this.refreshAction.run(delay, () => {
			this.refreshAction.wait();
			this.api.task.list(options, tasks => {
				this.refreshAction.release();
				if (deferredCount === this.refreshAction.count) {
					tasks.list.result.forEach(task => {
						if (task.area) task.area = JSON.parse(task.area);
						if (task.category) task.category = JSON.parse(task.category);
						if (task.labour_types) task.labour_types = JSON.parse(task.labour_types);
						if (task.notes) task.notes = JSON.parse(task.notes);
						if (task.active_working_users) task.active_working_users = JSON.parse(task.active_working_users);
						task.combined_quotes = JSON.parse(task.combined_quotes);
						if (task.combined_quotes) {
							task.combined_quotes = task.combined_quotes.filter(
								(quote, index, self) => index === self.findIndex((q) => q.quote_id === quote.quote_id)
							);
						}
					});
					this.tasks = tasks;
					this.service.clearExpanded();
					this.pagination.applyData(tasks.list);
					this.taskCount.emit(tasks.list.total_rows);
				}
				this.cdr.detectChanges();
			}, error => {
				if (deferredCount === this.refreshAction.count) {
					this.app.notifications.showDanger(error.message);
				}
			});
		});
	}

	resolveStage(s = null) {
		if (this.stage) {
			if (this.service.resolveStageFilter(s) == null) return this.stage;
			return this.service.resolveStageFilter(s);
		}
		return this.service.resolveStageFilter(s);
	}

	sortBy(field) {
		if (this.taskSortList === field) {
			this.taskSortList = '!' + field;
		} else {
			this.taskSortList = field;
		}

		this.refreshList();
	}

	sortClass(field) {
		if (this.taskSortList === field) {
			return 'wq wq-caret-up text-secondary text-large';
		} else if (this.taskSortList === '!' + field) {
			return 'wq wq-caret-down text-secondary text-large';
		} else {
			return '';
		}
	}

	// Helper function to determine filtered value or null
	getFilteredValue(filterArray) {
		return (filterArray.length === 0) ? null : filterArray;
	}

	selectStageFilter(stage) {
		if (this.service.stageFilter === stage) return;
		this.service.stageFilter = stage;
		this.refreshList();
	}

	stageTotal(s) {
		if (!this.tasks) return '';

		let list = this.resolveStage(s);
		if (!list) list = Object.keys(this.tasks.stage_totals);

		let total = 0;
		list.forEach(stage => {
			total += this.tasks.stage_totals[stage]?.count || 0;
		});

		return total;
	}

	handleSelectionChange(data, filterType: string): void {
		const filterMap = {
			project: 'projectFilter',
			system: 'systemFilter',
			area: 'areaFilter',
			labourType: 'labourTypeFilter',
			team: 'teamFilter',
			user: 'userFilter',
			phase: 'phaseFilter'
		};

		const filterProperty = filterMap[filterType];
		if (filterProperty) {
			this.service[filterProperty] = Mangler.clone(data);
			this.refreshList();
		}
	}

	clearAllFilters() {
		if (!this.projectId) this.service.projectFilter = [];
		if (!this.work_order_id) this.service.workOrderFilter = [];
		this.service.systemFilter = [];
		this.service.areaFilter = [];
		this.service.labourTypeFilter = [];
		this.service.teamFilter = [];
		this.service.userFilter = [];
		this.service.phaseFilter = [];
		this.refreshList();
	}

	isAnyFilterActive(): boolean {
		const filters = [
			this.service.systemFilter,
			this.service.areaFilter,
			this.service.labourTypeFilter,
			this.service.teamFilter,
			this.service.userFilter,
			this.service.phaseFilter
		];
		if (!this.projectId) filters.push(this.service.projectFilter);
		if (!this.work_order_id) filters.push(this.service.workOrderFilter);
		return filters.some(filter => filter.length > 0);
	}

	getCompletedDependencies(dependencies: any[]): number {
		return dependencies.filter(dep => dep.done === 1).length;
	}

	goToProject(id) {
		window.open(this.app.org + '/project/' + id);
	}

	taskDetailsModalClosed(_data) {
		this.refreshList();
	}

}
